import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const PharmacyNeighbor = types.compose(
  BaseEntity,
  types.model('PharmacyNeighbor', {
    pharmacyNeighborId: types.identifierNumber,
    pharmacyId: types.integer,
    neighborId: types.integer,
    density: types.maybe(types.integer),
    distance: types.maybe(types.integer),
  }),
);
